
const Cam2CamControls = {
  mounted(){
    console.log("Cam2CamBroadcasterComponent mounted")
    import("./cam2cam_broadcaster.js").then( ({ Cam2CamBroadcaster }) => {
      console.log(Cam2CamBroadcaster)
      this._cam2camBroadcaster = new Cam2CamBroadcaster(this)
    })
  },
  destroyed(){
    console.log("Cam2CamBroadcasterComponent destroyed")
    if (this._cam2camBroadcaster){
      this._cam2camBroadcaster.destroy()
    }
  }
}

export default { Cam2CamControls }

